import { call, CallEffect, PutEffect } from "redux-saga/effects";
import { automaticApi } from "@/settings/api";
import { clearString } from "@/utils/functions";
import environment from "@/settings/environment";
import { Action } from "redux-saga";
import { AxiosResponse } from "axios";

export interface Fetch {
  document: string;
  callback: (success: boolean) => void;
}

export interface SendPinForgotAction {
  type: string;
  payload: Fetch;
}

const uri = `/login-app/${environment.api?.loginVersion ?? "v1"}/recuperarSenha/sms`;

export default function* sendPinForgot({
  payload,
}: SendPinForgotAction): Generator<
  CallEffect<unknown> | PutEffect<Action>,
  void,
  AxiosResponse
> {
  const data = {
    cpf: clearString(payload.document),
  };

  try {
    yield call(automaticApi.post, uri, data);

    yield call(payload.callback, true);
  } catch (error) {
    yield call(payload.callback, false);
  }
}
